(() => {
  if (
    window.swinger
    && window.swinger.config
    && window.swinger.config.mediaqueries
    && window.swinger.config.mediaqueries.smallerThanLarge
  ) {
    const breakpoint = window.matchMedia(window.swinger.config.mediaqueries.smallerThanLarge);
    let isSmall = breakpoint.matches;

    breakpoint[breakpoint.addEventListener ? 'addEventListener' : 'addListener']('change', (e) => {
      isSmall = e.matches;
    });

    const elemVisibility = window.WeakMap ? new WeakMap() : new Map();

    const handleBasedOnMQ = (elem, startsVisible, closeFn) => {
      window.swinger.visibility[startsVisible ? 'show' : 'hide'](elem);

      const handleVisibilityChange = () => {
        const isVisible = !!elemVisibility.get(elem);

        switch (true) {
          default:
            break;

          case (!isSmall):
            window.swinger.navigationHelper.releaseNav(elem);
            window.swinger.overlayManager.unregister(elem);
            window.swinger.visibility.show(elem, true);
            break;

          case (isSmall && isVisible):
            window.swinger.overlayManager.register(elem, closeFn, undefined, true);
            window.swinger.navigationHelper.captureNav(elem);
            break;

          case (isSmall && !isVisible):
            window.swinger.navigationHelper.releaseNav(elem);
            window.swinger.overlayManager.unregister(elem);
            window.swinger.visibility.hide(elem);
            break;
        }
      };

      breakpoint[breakpoint.addEventListener ? 'addEventListener' : 'addListener']('change', () => {
        handleVisibilityChange();
      });

      window.swinger.visibility.observe(elem, (isVisible) => {
        elemVisibility.set(elem, isVisible);
        handleVisibilityChange();
      });
    };

    window.swinger.observer.initialize('#swinger-filter-wrapper', (elem) => {
      const firstFocusableElementsInResults = document.querySelector(window.swinger.focusableElements.map((selector) => `.swinger-results ${selector}`).join(','));
      const closeFn = () => {
        switch (true) {
          default:
            [firstFocusableElementsInResults || document.body].focus();
            break;

          case !elem.contains(document.activeElement):
            break;

          case isSmall:
            document.querySelector('#swinger-filters__toggle').focus();
            break;
        }
        window.swinger.visibility.hide(elem);
      };

      handleBasedOnMQ(elem, !isSmall, closeFn);

      breakpoint[breakpoint.addEventListener ? 'addEventListener' : 'addListener']('change', (e) => {
        if (!e.matches) {
          window.swinger.visibility.show(elem);
        }
      });
    }, false);
  }

  window.swinger.eventHub.register('change', '.swinger-facetted-search [data-fingerprint="hide-owned"] input[type="checkbox"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (elem.checked) {
      window.swinger.storage.set('swinger:facetted-search:hide-owned', 'on');
    } else {
      window.swinger.storage.remove('swinger:facetted-search:hide-owned');
    }
  });

  window.swinger.eventHub.register('click', '.swinger-facetted-search input[name="filter[streaming_type]"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const value = elem.value;

    if (value === 'scene') {
      window.swinger.storage.set('swinger:facetted-search:last-selected-streaming-type', value);
    } else {
      window.swinger.storage.remove('swinger:facetted-search:last-selected-streaming-type');
    }
  });

  window.addEventListener('resize', () => {
    document.documentElement.style.removeProperty('--swinger-facetted-search-height');
  }, {
    capture: true,
    once: true,
  });

  document.addEventListener('swinger-widget:rendered', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const facettedSearch = elem.querySelector('.swinger-facetted-search');

    if (!facettedSearch) {
      return;
    }

    document.documentElement.style.removeProperty('--swinger-facetted-search-height');
  });

  // eslint-disable-next-line no-constant-condition
  if (true || window.swinger.config.environment !== 'templates') {
    return;
  }

  window.lastState = undefined;

  window.addEventListener('popstate', () => { window.lastState = 'popstate'; });
  window.addEventListener('pushstate', () => { window.lastState = 'pushstate'; });
  window.addEventListener('replacestate', () => { window.lastState = 'replacestate'; });

  let moreResultsButtonClickBlocked = false;
  const moreResultsButtonObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      console.log(window.lastState);

      if (!entry.isIntersecting) {
        window.lastState = undefined;
        return;
      }

      if (window.lastState) {
        return;
      }

      if (moreResultsButtonClickBlocked) {
        return;
      }

      entry.target.click();

      moreResultsButtonClickBlocked = true;
      window.setTimeout(() => {
        moreResultsButtonClickBlocked = false;
      }, 3000);
    });
  }, {
    rootMargin: '0% 0% 30% 0%',
    threshold: [0, 0.001, 0.1, 0.25, 0.5, 1],
  });

  window.swinger.observer.initialize('.swinger-facetted-search .swinger-results__show-more-button', (elem) => {
    moreResultsButtonObserver.observe(elem);
  });
})();
